app.controller("ItemSelectionDetailsController", [
    "$scope", "StSubject", "$uibModalInstance", "examItem", "ExamsManagerService", "toastr",
    function ($scope, StSubject, $uibModalInstance, examItem, ExamsManagerService, toastr) {
        $scope.examItem = examItem;
        $scope.subject = examItem.subjectSelection;
        $scope.grades = examItem.subjectSelection.details;

        $scope.gradeColor = function (grade) {
            if (grade.grade && grade.grade.absolute && grade.minValue > grade.grade.absolute) return 'red';
            if (grade.replaced) return 'gray';
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        function changeStatus(status, toastMessage) {
            return ExamsManagerService.changeItemStatus({status: status, examItemId: examItem._id}).then(function () {
                toastr.success('', toastMessage);
                $uibModalInstance.close();
            });
        }

        $scope.approve = function () {
            return changeStatus('approved', 'გამოცდა ნებადართულია');
        };

        $scope.conditionalApprove = function () {
            return changeStatus('conditional', 'გამოცდა ნებადართულია წინაპირობით (მაგ. ქვითარი)');
        };

        $scope.reject = function () {
            return changeStatus('rejected', 'გამოცდის მოთხოვნა უარყოფილია');
        };
    }
]);
